import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { Database } from "@/integrations/supabase/types";
import { toast } from 'sonner';
import { useCurrentUserRole } from './useCurrentUserRole';

type OrganizationMember = Database['public']['Tables']['organization_members']['Row'];

export const useOrganizationMembersWithRole = (organizationId?: string) => {
  const [members, setMembers] = useState<OrganizationMember[]>([]);
  const [loading, setLoading] = useState(true);
  const { isAdmin } = useCurrentUserRole();

  const fetchMembers = async () => {
    if (!organizationId) {
      console.log('No organization ID provided to useOrganizationMembersWithRole');
      setLoading(false);
      return;
    }

    try {
      console.log('Fetching members for organization:', organizationId, 'isAdmin:', isAdmin);
      
      // Use the secure function that automatically filters sensitive data based on admin status
      const { data, error } = await supabase
        .rpc('get_organization_colleagues', { org_id: organizationId });

      if (error) {
        console.error('Error fetching members:', error);
        toast.error('Failed to load organization members');
        throw error;
      }

      console.log('Fetched members:', data);
      setMembers(data || []);
    } catch (error) {
      console.error('Error in useOrganizationMembersWithRole:', error);
      setMembers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
  }, [organizationId, isAdmin]);

  return {
    members,
    loading,
    refetchMembers: fetchMembers,
    isAdmin
  };
};